var m = require('mithril');
var prop = require('mithril/stream')
var key = require('../../libs/keybindings');
var telegraph = require('../../libs/Telegraph');
var buttonElement = require('../../components/button');
var pageScrollLock = require('./pageScrollLock');

var modal = {};
var releasePageScrollLock = null;

telegraph(modal);


modal.vm = {
  title: prop(null),
  buttons: prop([]),
  body: 'span',
  opened: prop(false),
  hideCloseIcon:prop(false),
  open: function (options) {
    modal.vm.opened(true);
    if (!releasePageScrollLock) {
      releasePageScrollLock = pageScrollLock.acquire();
    }
    modal.emit('opened');
    key.setScope('modal');
  },
  close : function (arg) {
    modal.vm.opened(false);
    if (releasePageScrollLock) {
      releasePageScrollLock();
      releasePageScrollLock = null;
    }
    key.setScope('home');
    modal.emit('closed');
    modal.vm.hideCloseIcon(false);
    modal.vm.buttons([]);
    modal.vm.body = prop(m('div')); // Trigger onremove for body 
  },
}

key('esc', 'modal', modal.vm.close);

modal.view = function (ctrl) {
  return m("div.bg-dark-gray", {style: {display: (modal.vm.opened() ? 'block' : 'none')}}, [
    m("div.fixed.top-0.h-100.w-100", {
      onclick: function(e) {
        if (e.target !== this || modal.vm.hideCloseIcon()) return;
        modal.vm.close();
      },
      style: {
        visibility: (modal.vm.opened() ? 'visible' : 'hidden'),
        background: 'rgba(0, 0, 0, 0.4)',
        zIndex: 999,
        overflowX: 'hidden',
        overflowY: 'auto',
        overscrollBehavior: 'contain'
      }
    }, [
      (function(){
        if(modal.vm.hideCloseIcon()){
          return m("div.bg-black.mt5.mh5.pa4.w-50-l.w-50-m.w-100-ns.center", {zIndex: 1000}, [
                  m("h2.fw3.mb4", modal.vm.title()),
                  (typeof modal.vm.body === 'function' ? modal.vm.body(): m(modal.vm.body)),
                  m('div.mt1.tc.tr-ns.mt4', [
                    modal.vm.buttons().map(function (button) {
                      return m(buttonElement, button)
                    })
                  ])
                ])
          } else {
            return m("div.bg-black.mt5.mh5.pa4.w-50-l.w-50-m.w-100-ns.center", {zIndex: 1000}, [
              m('i.ion-close.fr', {onclick: modal.vm.close}),
              m("h2.fw3.mb4", modal.vm.title()),
              (typeof modal.vm.body === 'function' ? modal.vm.body(): m(modal.vm.body)),
              m('div.mt1.tc.tr-ns.mt4', [
                modal.vm.buttons().map(function (button) {
                  return m(buttonElement, button)
                })
              ])
            ])
          }
      })(),
    ])
  ])
}

module.exports = modal;
